import { createContext } from 'react';
import { ResourcesConfig } from 'aws-amplify';

export const AppContext = createContext<ResourcesConfig | null>(null);
